import { Button, Col, Form, Row, Select, Spin } from "antd";
import axios from "axios";
import { Company } from "@bindeleddet/core/types";
import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import CompanyCard from "../CreateOrEditEvent/Cards/CompanyCard";

const { Option } = Select;

const SelectCompanyForNewEvent = () => {
  const [data, setData] = useState<Company[]>([]);
  const [selectedCompany, setSelectedCompany] = useState<number>();
  const [loading, setLoading] = useState<boolean>(true);
  const [timeoutId, setTimeoutId] = useState<ReturnType<typeof setTimeout>>();
  const fetchCompanies = useCallback((search = "") => {
    setLoading(true);
    const params = new URLSearchParams({
      page: "1",
      page_size: "10",
    });

    if (search && search.length > 0) {
      params.append("search", search);
    }

    axios
      .get<{ results: Company[]; count: number }>(`/companies/?${params.toString()}`)
      .then(response => {
        setData(response.data.results);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  const handleSearch = (value: string) => {
    // Debounce search to prevent too many requests
    setLoading(true);
    setData([]);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const newTimeoutId = setTimeout(() => {
      fetchCompanies(value);
    }, 300);
    setTimeoutId(newTimeoutId);
  };

  return (
    <CompanyCard title="Velg bedrift for nytt arrangement">
      <Row gutter={[16, 16]}>
        <Col md={12} xs={24}>
          <Form.Item name="is_open">
            <Select
              onChange={setSelectedCompany}
              size="large"
              style={{ width: "98%" }}
              placeholder="Velg bedrift"
              notFoundContent={
                loading ? (
                  <div style={{ textAlign: "center" }}>
                    <Spin size="default" />
                  </div>
                ) : (
                  "Ingen bedrifter funnet"
                )
              }
              showSearch
              onSearch={handleSearch}
              filterOption={false}
              loading={loading}
            >
              {data?.map(company => (
                <Option key={company.id} value={company.id}>
                  {company.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Link to={`/admin/events/new/${selectedCompany}`} style={{ display: "flex", justifyContent: "end" }}>
            <Button type="primary" size="large" disabled={!selectedCompany} style={{ width: "100%" }}>
              Opprett nytt arrangement
            </Button>
          </Link>
        </Col>
      </Row>
    </CompanyCard>
  );
};

export default SelectCompanyForNewEvent;
